import { render, staticRenderFns } from "./batchFee.vue?vue&type=template&id=9cb59776&scoped=true&"
import script from "./batchFee.vue?vue&type=script&lang=js&"
export * from "./batchFee.vue?vue&type=script&lang=js&"
import style0 from "./batchFee.vue?vue&type=style&index=0&id=9cb59776&lang=less&scoped=true&"
import style1 from "./batchFee.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb59776",
  null
  
)

export default component.exports